var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuegoOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4375 29.625V59.25C42.6827 59.25 55.7459 46.0457 55.7459 29.625V0C39.5007 0 26.4375 13.2043 26.4375 29.625Z",
    fill: "#FF972F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.083 40.9671V59.25C12.0345 59.25 3.99561 51.1242 3.99561 40.9671V22.8535C13.8767 22.8535 22.083 30.9792 22.083 40.9671Z",
    fill: "#FF972F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuegoOrange);
export default __webpack_public_path__ + "static/media/fuego-orange.0410373540ef98b553ec711dbb198db7.svg";
export { ForwardRef as ReactComponent };